/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_PlaceholderInputs */

const en_interview_practice_placeholder = /** @type {(inputs: Interview_Practice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type your answer here (minimum 10 characters)...`)
};

const de_interview_practice_placeholder = /** @type {(inputs: Interview_Practice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib hier deine Antwort ein (mindestens 10 Zeichen)...`)
};

const fr_interview_practice_placeholder = /** @type {(inputs: Interview_Practice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tape ta réponse ici (minimum 10 caractères)...`)
};

const es_interview_practice_placeholder = /** @type {(inputs: Interview_Practice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escriba su respuesta aquí (mínimo 10 caracteres)...`)
};

const it_interview_practice_placeholder = /** @type {(inputs: Interview_Practice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivi qui la tua risposta (minimo 10 caratteri)...`)
};

const nl_interview_practice_placeholder = /** @type {(inputs: Interview_Practice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ hier je antwoord (minimaal 10 tekens)...`)
};

const pl_interview_practice_placeholder = /** @type {(inputs: Interview_Practice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpisz tutaj swoją odpowiedź (minimum 10 znaków)...`)
};

const fi_interview_practice_placeholder = /** @type {(inputs: Interview_Practice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjoita vastauksesi tähän (vähintään 10 merkkiä)...`)
};

const da_interview_practice_placeholder = /** @type {(inputs: Interview_Practice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skriv dit svar her (mindst 10 tegn)...`)
};

const sv_interview_practice_placeholder = /** @type {(inputs: Interview_Practice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skriv ditt svar här (minst 10 tecken)...`)
};

/**
* | output |
* | --- |
* | "Type your answer here (minimum 10 characters)..." |
*
* @param {Interview_Practice_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_placeholder = /** @type {((inputs?: Interview_Practice_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_placeholder(inputs)
	if (locale === "fr") return fr_interview_practice_placeholder(inputs)
	if (locale === "es") return es_interview_practice_placeholder(inputs)
	if (locale === "it") return it_interview_practice_placeholder(inputs)
	if (locale === "nl") return nl_interview_practice_placeholder(inputs)
	if (locale === "pl") return pl_interview_practice_placeholder(inputs)
	if (locale === "fi") return fi_interview_practice_placeholder(inputs)
	if (locale === "da") return da_interview_practice_placeholder(inputs)
	if (locale === "sv") return sv_interview_practice_placeholder(inputs)
	return en_interview_practice_placeholder(inputs)
});